export { default } from './InlineAlert';
